module.exports = __WEBPACK_EXTERNAL_MODULE_220__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/switchMap","commonjs2":"rxjs/add/operator/switchMap","amd":"rxjs/add/operator/switchMap"}
// module id = 220
// module chunks = 0 1